import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { motion } from 'framer-motion';
import logoImage from '../../asset/Pink.png'; // Import the logo image
// Import icons (you'll need to install react-icons: npm install react-icons)
import { FaInstagram, FaFacebook, FaTiktok } from 'react-icons/fa';

const Navbar = () => {
  // const [isScrolled, setIsScrolled] = useState(false);
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);

  const toggleSideMenu = () => {
    setIsSideMenuOpen(!isSideMenuOpen);
    // Add or remove class from body
    if (!isSideMenuOpen) {
      document.body.classList.add('side-menu-open');
    } else {
      document.body.classList.remove('side-menu-open');
    }
  };

  useEffect(() => {
    // Cleanup function only
    return () => {
      document.body.classList.remove('side-menu-open');
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-blur-background"></div>
      <div className="navbar-container">
        {/* Left side - Logo */}
        <div className="navbar-logo">
          <a href="/">
            <motion.img 
              src={logoImage} 
              alt="Fluid Logo"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            />
          </a>
        </div>

        {/* Center - Desktop Menu */}
        <div className="navbar-center-menu">
          <ul>
            <motion.li
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <a href="/">Home</a>
            </motion.li>
            <motion.li
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <a href="/projects">Projects</a>
            </motion.li>
            <motion.li
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <a href="/about">About</a>
            </motion.li>
            <motion.li
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <a href="/contact">Contact</a>
            </motion.li>
          </ul>
        </div>

        {/* Right side - Burger menu */}
        <div className="navbar-burger" onClick={toggleSideMenu}>
          <div className={`hamburger ${isSideMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Side Menu - Mobile */}
        <div className={`side-menu ${isSideMenuOpen ? 'open' : ''}`}>
          <ul className="side-menu-nav">
            <li className="close-button-container">
              <span className="close-button" onClick={toggleSideMenu}>&times;</span>
            </li>
            <li><a href="/" onClick={toggleSideMenu}>Home</a></li>
            <li><a href="/projects" onClick={toggleSideMenu}>Projects</a></li>
            <li><a href="/about" onClick={toggleSideMenu}>About</a></li>
            <li><a href="/contact" onClick={toggleSideMenu}>Contact</a></li>
          </ul>
          
          <div className="social-icons">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">
              <FaTiktok />
            </a>
          </div>
        </div>
        
        {/* Overlay for side menu */}
        {isSideMenuOpen && <div className="side-menu-overlay" onClick={toggleSideMenu}></div>}
      </div>
    </nav>
  );
};

export default Navbar; 